<template>
  <div v-if="segment || (cardType && cardType.length)" class="benefit-filter-list" :class="{ 'benefit-filter-list--short': useShortName }">
    <span v-if="segment" class="benefit-filter-list-item">
      {{ segment }}
    </span>
    <template v-for="(item, index) in cardType">
      <span v-if="Object.values(item).includes(true) || item.active === true" :key="item.id || index"
        class="benefit-filter-list-item">
        {{ useShortName && item.short_name ? item.short_name : item.name }}
      </span>
    </template>
  </div>
</template>

<script>
export default {
  name: 'benefit-filter-list',
  props: {
    segment: {
      type: [String, Number],
      default: ''
    },
    cardType: {
      type: Array,
      default: () => []
    },
    useShortName: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="less" scoped>
@import "../../../styles/vars.less";

.benefit-filter-list {
  display: flex;
  gap: 16px;
  margin-bottom: 40px;
  flex-wrap: wrap;

  .benefit-filter-list-item {
    display: inline-block;
    padding: 11px 18px;
    line-height: 1.1;
    font-size: 1rem;
    border-radius: 20px;
    color: @white;
    font-family: @bold;
    background: @blue;
  }

  &--short {
    gap: 8px;
    margin-bottom: 28px;

    .benefit-filter-list-item {
      padding: 8px 16px;
      font-size: 0.875rem;
    }
  }
}
</style>